import { isUndefined } from "../utils/index";
export class IntersectionHelper {
  constructor(range = []) {
    this.range = range;

    this.handleIntersect = entrys => {
      entrys.forEach(entry => {
        const {
          target,
          isIntersecting
        } = entry;
        if (!isIntersecting) return;
        const currentY = entry.boundingClientRect.top;
        const currentRatio = entry.intersectionRatio;
        const info = this.stayWeakMap.get(target) || {};
        let {
          previousY = -1,
          previousRatio = 0,
          currentT = this.getNow(),
          stay
        } = info;
        let currentStayRangeMap = stay;

        if (isUndefined(stay)) {
          currentStayRangeMap = new Map();
        }

        let currInterest = 0;

        if (previousY === -1 || currentY < previousY) {
          if (currentRatio > previousRatio && isIntersecting) {
            currInterest = currInterest | IntersectionHelper.SCROLL_DOWN_ENTER;
          } else {
            currInterest = currInterest | IntersectionHelper.SCROLL_DOWN_LEAVE;
          }
        } else if (currentY > previousY && isIntersecting) {
          if (currentRatio < previousRatio) {
            currInterest = currInterest | IntersectionHelper.SCROLL_UP_ENTER;
          } else {
            currInterest = currInterest | IntersectionHelper.SCROLL_UP_LEAVE;
          }
        }

        const now = this.getNow();
        const currentTick = {
          previousY: currentY,
          previousRatio: currentRatio,
          previousT: currentT,
          currentT: now,
          stay: currentStayRangeMap
        };
        const elapsedTime = now - currentT;
        const previousIndex = this.getNextIndex(previousRatio);
        const timeInPerSlot = elapsedTime;
        this.addStayTimeToSlot(currentStayRangeMap, timeInPerSlot, currInterest, this.range[previousIndex]);
        this.stayWeakMap.set(target, currentTick);

        for (const [key, cb] of Object.entries(this.interests)) {
          const index = +key;

          if (this.has(index, currInterest)) {
            cb && cb(entry, currentTick, {
              interests: currInterest,
              range: this.range
            });
          }
        }
      });
    };

    this.stayWeakMap = new WeakMap();
    this.interests = {};
  }

  has(k1, k2) {
    return (k1 & k2) !== 0;
  }

  cleanRangeStayTime(target) {
    const info = this.stayWeakMap.get(target);

    if (isUndefined(info === null || info === void 0 ? void 0 : info.stay)) {
      return;
    }

    this.stayWeakMap.delete(target);
  }

  getNow() {
    const n = window.performance && performance.now && performance.now();
    return n || Date.now();
  }

  register(interest, cb) {
    this.interests[interest] = cb;
    return this;
  }

  getNextIndex(point) {
    const r = this.range;
    let idx = 0;

    for (; idx < r.length; idx++) {
      if (point <= r[idx]) {
        break;
      }
    }

    return idx;
  }

  toFixed(s_num) {
    return Number(s_num).toFixed(2);
  }

  iteratorInRange(start, end, cb) {
    for (let idx = start; idx < end; idx++) {
      cb && cb(idx);
    }
  }

  addStayTimeToSlot(rangeStayTime, totalTime, scrollStatus, currentTriggerPoint) {
    if (typeof currentTriggerPoint === 'undefined') {
      return;
    }

    const rangeMap = rangeStayTime.get(scrollStatus) || new Map();
    const {
      times = 0
    } = rangeMap.get(currentTriggerPoint) || {};
    rangeMap.set(currentTriggerPoint, {
      times: totalTime + times
    });
    rangeStayTime.set(scrollStatus, rangeMap);
  }

  isNullOrUndefined(target, key) {
    return target[key] === null || typeof target[key] === 'undefined';
  }

  initEnhancedIntersectionObserver() {
    return args => {
      try {
        this.handleIntersect(args);
      } catch (e) {}
    };
  }

  enhancedViewStay(target) {
    var _a;

    var collected = {};

    try {
      const {
        SCROLL_DOWN_ENTER,
        SCROLL_UP_LEAVE
      } = IntersectionHelper;
      const stayMap = (_a = this.stayWeakMap.get(target)) === null || _a === void 0 ? void 0 : _a.stay;

      if (isUndefined(stayMap)) {
        return;
      }

      for (const [k, v] of stayMap.entries()) {
        let direction = 'bottom';

        if (k === SCROLL_DOWN_ENTER || k === SCROLL_UP_LEAVE) {
          direction = 'top';
        }

        v.forEach(({
          times
        }, threshHold) => {
          let prev;
          collected[`${threshHold}_${direction}`] = prev = collected[`${threshHold}_${direction}`] || 0;
          collected[`${threshHold}_${direction}`] += prev + times;
        });
      }

      this.cleanRangeStayTime(target);
      return collected;
    } finally {
      return collected;
    }
  }

}
IntersectionHelper.SCROLL_DOWN_ENTER = 1 << 0;
IntersectionHelper.SCROLL_DOWN_LEAVE = 1 << 1;
IntersectionHelper.SCROLL_UP_ENTER = 1 << 2;
IntersectionHelper.SCROLL_UP_LEAVE = 1 << 3;